const ResetModal = function () {
  //this.addRole.hideModal()
  this.addRole.resetForm()
  this.addRole.loader.hideLoader()
  this.addRole.submitButton.setEnabled()
}

export default ResetModal
